const POSTHOG_KEY = "phc_DbsPb39SRc8z3EiQ6Dhj6ikv4H4rTKcht9d4sZSesceP";
const POSTHOG_HOST = "https://ap.emergent.sh";

export function enablePosthog() {
  if (typeof window === "undefined") return;
  if (window.posthog?.__a4pInitialized) {
    if (typeof window.posthog.opt_in_capturing === "function") window.posthog.opt_in_capturing();
    if (typeof window.posthog.startSessionRecording === "function") window.posthog.startSessionRecording();
    return;
  }

  let posthog = window.posthog;
  if (!posthog || !posthog.__SV) {
    posthog = window.posthog = [];
    posthog._i = [];
    posthog.init = function (key, config, name) {
      const target = name ? (posthog[name] = posthog[name] || []) : posthog;
      target.people = target.people || [];
      target.toString = function (stub) { return `posthog${name ? `.${name}` : ""}${stub ? " (stub)" : ""}`; };
      target.people.toString = function () { return `${target.toString(1)}.people (stub)`; };
      const methods = "capture identify alias group reset setPersonProperties setPersonPropertiesForFlags register register_once unregister get_distinct_id get_session_id opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing startSessionRecording stopSessionRecording sessionRecordingStarted".split(" ");
      methods.forEach((method) => {
        target[method] = function (...args) { target.push([method, ...args]); };
      });
      posthog._i.push([key, config, name]);
    };
    posthog.__SV = 1;
  }

  if (!posthog.__a4pScriptAdded) {
    const script = document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `${POSTHOG_HOST.replace(".i.posthog.com", "-assets.i.posthog.com")}/static/array.js`;
    document.head.appendChild(script);
    posthog.__a4pScriptAdded = true;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
  });
  posthog.__a4pInitialized = true;
}

export function disablePosthog() {
  if (typeof window === "undefined" || !window.posthog) return;
  if (typeof window.posthog.opt_out_capturing === "function") {
    window.posthog.opt_out_capturing({ clear_persistence: true });
  }
  if (typeof window.posthog.stopSessionRecording === "function") window.posthog.stopSessionRecording();
}
